import API from './api';
import CLIPBOARD from './clipboard';
import COMMON from './common';
import CURRENT_LOCATION from './currentLocation';
import ICONS from './icons';
import JSONP from './jsonp';
import LOCATION_INFO from './locationInfo';
import PRINT from './print';
import MAP from './map';
import SEARCH from './search';
import URLS from './urls';
import WEATHER from './weather';

const config = {
  accessToken: process.env.REACT_APP_MAP_ACCESS_TOKEN,
  api: API,
  clipboard: CLIPBOARD,
  common: COMMON,
  currentLocation: CURRENT_LOCATION,
  icons: ICONS,
  jsonp: JSONP,
  locationInfo: LOCATION_INFO,
  print: PRINT,
  map: MAP,
  search: SEARCH,
  urls: URLS,
  weather: WEATHER,

};

export default config;
